import script from "./CompanyInformationFormAdvice.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyInformationFormAdvice.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyInformationFormAdvice.vue?vue&type=style&index=0&id=4d44389c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d44389c"]])

export default __exports__